import { FormGroup } from '@angular/forms';

export function matchingToValidator(key: string, equalToKey: string) {
  return (group: FormGroup): {
    [key: string]: any
  } => {
    if (!group || !group.controls) {
      return { mismatched: false };
    }

    const value = group.controls[key].value;
    const comparedTo = group.controls[equalToKey].value;

    if (value !== comparedTo) {
      return {
        mismatched: true
      };
    }
  };
}
